module.exports = __webpack_public_path__ + "static/media/chauffeur.3ed67b85.svg";